import { GeofencesService } from '../services/geofences-service';
import { WhaleZonesModelBase } from './whale-zones-model';
import { ZoneFeature } from './zones-base-interfaces';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

export class WhaleZonesModelImpl extends WhaleZonesModelBase {
private _whaleZones: ZoneFeature[] | null = null;

constructor(geojson?: ZoneFeature[]) {
    super();

    if (geojson) {
        // for test files
        this._whaleZones = geojson;
    } else {
        setInterval(() => this.fetchZones(), 60*60*1000); // refresh the list every 1h
    }
}

public async allZones(): Promise<ZoneFeature[] | null> {
    if(!this._whaleZones) {
        await this.fetchZones();
    }
    return this._whaleZones;
}

public async allActiveZones(fromDate: Date, toDate: Date): Promise<ZoneFeature[] | null> {
    if(!this._whaleZones) {
        await this.fetchZones();
    }

    if (!this._whaleZones) {
        return null;
    }

    const activeZones: ZoneFeature[] = [];
    this._whaleZones.forEach(f => {

        if(!f.properties || !f.properties[0]) {
            return;
        }

        const seasonalityFrom = new Date(f.properties[0]?.seasonality_from!);
        const seasonalityTo = new Date(f.properties[0]?.seasonality_to!);
        const validFrom = f.properties[0]?.valid_from;
        
        if (validFrom) {
            const validFromDate = new Date(validFrom);
            if (validFromDate > toDate) {
                return;
            }
        }

        // extracting month and day 
        const fromMonth = seasonalityFrom.getUTCMonth();
        const fromDay = seasonalityFrom.getUTCDate();
        const toMonth = seasonalityTo.getUTCMonth();
        const toDay = seasonalityTo.getUTCDate();

        // using year from query fromDate for the zone dates
        const fromYear = fromDate.getUTCFullYear();
        let zoneFrom = new Date(Date.UTC(fromYear, fromMonth, fromDay));
        let zoneTo = new Date(Date.UTC(fromYear, toMonth, toDay));

        // if zone from > zone to, the zone crosses into next year
        if (zoneFrom > zoneTo) {
            // checking if we need to adjust to previous year or next year
            const now = fromDate;
            if (now >= zoneFrom) {
                zoneTo = new Date(Date.UTC(fromYear + 1, toMonth, toDay));
            } else {
                zoneFrom = new Date(Date.UTC(fromYear - 1, fromMonth, fromDay));
            }
        }

        if ((toDate >= zoneFrom && toDate <= zoneTo) || (fromDate >= zoneFrom && fromDate <= zoneTo) || (fromDate <= zoneFrom && toDate >= zoneTo)) {
            activeZones.push(f);
        }
    });
    
    return activeZones;
}

private async fetchZones() {
    try {
      if (isVesselOnCloud && !isOnline()) {
        const cached = await IndexedDBService.zones.getByType('WHALE');
        if (cached) {
          this._whaleZones = cached;
        }
        return;
      }
      const whaleZones: ZoneFeature[] = await GeofencesService.fetchGeofenceByZone('WHALE');
      if (whaleZones) {
        this._whaleZones = whaleZones;
        await IndexedDBService.zones.save('WHALE', whaleZones);
      }
    } catch (error) {
      console.warn('Failed to fetch WHALE zones from API, falling back to IndexedDB', error);
      const cached = await IndexedDBService.zones.getByType('WHALE');
      if (cached) {
        this._whaleZones = cached;
      }
    }
}
}